import { useEffect } from "react";
import { AuthorizePageView } from "./_components";

const AuthorizePage = () => {
  useEffect(() => {
    document.title = "Authorize - Vetty 3D";
  }, []);

  return <AuthorizePageView />;
};

export default AuthorizePage;
